function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import startsWith from 'lodash/startsWith';
import { AppContext } from 'context';
import Link from 'components/Link';
import HelpIcon from 'svg/ap/help.svg';
import InformationIcon from 'svg/ap/information.svg';
import InformationActiveIcon from 'svg/ap/information-active.svg';
// import IntegrationIcon from 'svg/ap/integration.svg';
import LogoutIcon from 'svg/ap/logout.svg';
import OrganizationIcon from 'svg/ap/organization.svg';
import PreferencesIcon from 'svg/ap/preferences.svg';
import PreferencesActiveIcon from 'svg/ap/preferences-active.svg';
import ServiceCatalogIcon from 'svg/ap/service-catalog.svg';
import App from 'modules/App';
import Account from 'modules/Account';
import CurrentVersion from './CurrentVersion';
import UserBox from './UserBox';
import BackButton from './BackButton';
import styles from './Sidebar.pcss';
var _React_PureComponent;
class Sidebar extends (_React_PureComponent = React.PureComponent) {
    onSignOut(evt) {
        evt.preventDefault();
        this.props.onSignOut();
    }
    /* eslint-disable max-len */ get navItems() {
        const { hasBusinessIdentity } = this.props;
        return [
            {
                key: 'information',
                to: 'personal-information',
                Icon: InformationIcon,
                ActiveIcon: InformationActiveIcon
            },
            {
                key: 'preferences',
                to: 'preferences',
                Icon: PreferencesIcon,
                ActiveIcon: PreferencesActiveIcon
            },
            // { key: 'integrations', to: 'test2risus', Icon: IntegrationIcon },
            {
                key: 'organizations',
                to: 'organization-memberships',
                Icon: OrganizationIcon,
                hidden: !hasBusinessIdentity
            },
            {
                key: 'serviceCatalog',
                to: 'app-catalog',
                newSection: true,
                Icon: ServiceCatalogIcon
            },
            {
                key: 'help',
                to: 'https://support.glucocontro.online/hc',
                target: '_blank',
                Icon: HelpIcon
            },
            {
                key: 'logOut',
                Icon: LogoutIcon,
                newSection: true,
                onClick: (evt)=>this.onSignOut(evt)
            }
        ];
    }
    /* eslint-enable max-len */ getIsActive(item) {
        return item.to === this.props.route.name;
    }
    getUrlTo(item) {
        if (!item.to) {
            return '';
        }
        if (startsWith(item.to, 'http') || startsWith(item.to, '//')) {
            return item.to;
        }
        return this.context.getUrl(item.to);
    }
    renderLogo() {
        return /*#__PURE__*/ _jsx("figure", {
            className: `col-auto ${styles.sidebar__logoContainer}`,
            children: /*#__PURE__*/ _jsx("img", {
                src: "/aid/assets/img/app-logo.png",
                className: styles.sidebar__logo,
                alt: "Contour Diabetes Care"
            })
        });
    }
    renderNavItem(item) {
        if (item.hidden) {
            return null;
        }
        const to = this.getUrlTo(item);
        const isActive = this.getIsActive(item);
        const isHovered = item.key === this.state.hovered;
        const Icon = (isActive || isHovered) && item.ActiveIcon ? item.ActiveIcon : item.Icon;
        return /*#__PURE__*/ _jsx("li", {
            className: cn(styles.sidebar__nav__list__item, {
                [styles['sidebar__nav__list__item--active']]: isActive,
                [styles['sidebar__nav__list__item--newSection']]: item.newSection
            }),
            onMouseEnter: ()=>this.setState({
                    hovered: item.key
                }),
            onMouseLeave: ()=>this.setState({
                    hovered: null
                }),
            children: /*#__PURE__*/ _jsxs(Link, {
                to: to,
                target: item.target,
                onClick: item.onClick,
                children: [
                    Icon && /*#__PURE__*/ _jsx(Icon, {
                        className: "mr-5"
                    }),
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.headers[item.key]))
                ]
            })
        }, item.key);
    }
    renderBackButton() {
        return /*#__PURE__*/ _jsx(BackButton, {});
    }
    renderNav() {
        return /*#__PURE__*/ _jsx("nav", {
            className: `col ${styles.sidebar__nav}`,
            children: /*#__PURE__*/ _jsx("ul", {
                className: styles.sidebar__nav__list,
                children: this.navItems.map((item)=>this.renderNavItem(item))
            })
        });
    }
    renderUserBox() {
        return /*#__PURE__*/ _jsx("div", {
            className: "col-auto",
            children: /*#__PURE__*/ _jsx(UserBox, {})
        });
    }
    renderAppVersion() {
        return /*#__PURE__*/ _jsx("div", {
            className: "col-auto",
            children: /*#__PURE__*/ _jsx(CurrentVersion, {})
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("aside", {
            className: styles.sidebar,
            children: [
                this.renderLogo(),
                this.renderBackButton(),
                this.renderNav(),
                this.renderUserBox(),
                this.renderAppVersion()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            hovered: null
        };
    }
}
_define_property(Sidebar, "contextType", AppContext);
_define_property(Sidebar, "propTypes", {
    // Implicit props
    hasBusinessIdentity: PropTypes.bool,
    route: App.shapes.route,
    // Implicit actions
    onSignOut: PropTypes.func
});
const mapStateToProps = (state)=>({
        hasBusinessIdentity: Account.selectors.hasBusinessIdentity(state),
        route: App.selectors.route(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onSignOut: ()=>dispatch(Account.actions.signOut())
    });
const ConnectedSidebar = connect(mapStateToProps, mapDispatchToProps)(Sidebar);
export default withStyles(styles)(ConnectedSidebar);
